var overArg = require('./_overArg');

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;



//////////////////
// WEBPACK FOOTER
// ../react-toastr/node_modules/lodash/_nativeKeys.js
// module id = 123
// module chunks = 0 1 2